module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Bateria.dc6dc1e1.png";